/**
 * Generated by orval v7.19.0 🍺
 * Do not edit manually.
 * GTO Wizard API v4
 * API documentation for GTO Wizard frontend API
 * OpenAPI spec version: 4
 */

export type AffiliatePayoutStatus =
  (typeof AffiliatePayoutStatus)[keyof typeof AffiliatePayoutStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AffiliatePayoutStatus = {
  REQUESTED: 'REQUESTED',
  PAID: 'PAID',
  REJECTED: 'REJECTED',
  CANCELLED: 'CANCELLED',
  REVERSED: 'REVERSED',
} as const
